export const TIMEZONE_OPTIONS = [
  { value: 'America/New_York', label: 'NY, USA', displayName: 'Eastern Time', abbreviation: 'ET' },
  { value: 'America/Chicago', label: 'Chicago, USA', displayName: 'Central Time', abbreviation: 'CT' },
  { value: 'America/Denver', label: 'Denver, USA', displayName: 'Mountain Time', abbreviation: 'MT' },
  { value: 'America/Los_Angeles', label: 'LA, USA', displayName: 'Pacific Time', abbreviation: 'PT' },
  { value: 'UTC', label: 'UTC', displayName: 'UTC', abbreviation: 'UTC' },
] as const

export type TimezoneOption = (typeof TIMEZONE_OPTIONS)[number]
export type AllowedTimezone = TimezoneOption['value']
export type SelectedTimezone = string & { readonly __selectedTimezoneBrand?: never }

export const LOCAL_BROWSER_TIMEZONE_MODE = 'LOCAL_BROWSER'

export type TimezoneMode = 'UTC' | typeof LOCAL_BROWSER_TIMEZONE_MODE | 'IANA'
export type TimeFormat = '12h' | '24h'
export type AppTimezonePreference = {
  timezoneMode: TimezoneMode
  timezone: AllowedTimezone
  timeFormat: TimeFormat
}

export const DEFAULT_APP_TIMEZONE_PREFERENCE: AppTimezonePreference = {
  timezoneMode: 'UTC',
  timezone: 'UTC',
  timeFormat: '24h',
}

export const APP_TIMEZONE_SELECTOR_OPTIONS = [
  { label: 'UTC', timezoneMode: 'UTC', timezone: 'UTC' },
  { label: 'Local (browser)', timezoneMode: LOCAL_BROWSER_TIMEZONE_MODE, timezone: 'UTC' },
  { label: 'Pacific', timezoneMode: 'IANA', timezone: 'America/Los_Angeles' },
  { label: 'Mountain', timezoneMode: 'IANA', timezone: 'America/Denver' },
  { label: 'Central', timezoneMode: 'IANA', timezone: 'America/Chicago' },
  { label: 'Eastern', timezoneMode: 'IANA', timezone: 'America/New_York' },
] as const satisfies readonly ({ label: string } & Pick<AppTimezonePreference, 'timezoneMode' | 'timezone'>)[]

export type AppTimezoneSelectorOption = (typeof APP_TIMEZONE_SELECTOR_OPTIONS)[number]
